export default "__VITE_ASSET__DFScI6Kr__"